module.exports = __webpack_public_path__ + "media/landing_work/home/images/star-purple-e719362a9b32bdec7ac4aeac5677aa20.svg";